import { useQuery } from '@tanstack/react-query';
import { getFileDownloadUrl } from '../../services/knowledgeService';

// The backend's SAS URL lives 20 minutes; refetch well before it expires
const PREVIEW_URL_STALE_MS = 15 * 60 * 1000;

// Short-lived URL for loading a knowledge PDF into the preview
export const useKnowledgeFilePreviewUrl = (
  knowledgeId: string,
  fileName: string | undefined
) =>
  useQuery<string, Error>({
    queryKey: ['knowledge-file-preview-url', knowledgeId, fileName],
    queryFn: async () => {
      const result = await getFileDownloadUrl(
        knowledgeId,
        fileName as string,
        'inline'
      );
      if (result?.status !== 'success') {
        throw new Error(result?.message ?? 'Could not load the preview');
      }
      return result.message.download_url as string;
    },
    enabled: !!fileName,
    staleTime: PREVIEW_URL_STALE_MS,
    gcTime: PREVIEW_URL_STALE_MS,
    refetchOnWindowFocus: false,
    retry: false,
  });
